<template>
    <v-row>
        <qrcode-stream @decode="onDecode"></qrcode-stream>
    </v-row>
</template>

<script>
export default {
    methods: {           
        onDecode (decodedString) {
            this.$router.push({name: 'AddUpdateOrder', params: {productId: decodedString, data: this.$route.params.data}});
        }
    },

    created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));
      
        let canOrder = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 216
        });

        if(canOrder == null)
            this.$router.push('menu');
    }
}
</script>